import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { APIPaymentService } from '../../_services/payment-dues/payment-dues.service';
import { APITemplateService } from '../../_services/template/API-template';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { formatDate } from '@angular/common';
import { APIConsentService } from '../../_services/consent/API-consent';
import { GstRegistrationService } from '../../_services/gst-registration/gst-registration.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalPromptEntityComponent } from '../../../../_helpers/Modals/prompt-entity/modal.prompt-entity';
import { saveAs as importedSaveAs } from "file-saver";
//below code for Current Data
const now = new Date();
const currentdate = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');

@Component({
  selector: 'app-linking_consent',
  templateUrl: './linking_consent.component.html',
  styleUrls: ['./linking_consent.component.css']
})
export class LinkingConsentComponent implements OnInit {
	  public modalRef: BsModalRef;
	verifyCSTempID = "start";
	returnedValue: any;
	cs_temp_content:any;
	entity_id: any;
	entity_name: any;
	template_id: any;
	isValid: boolean = false;
	isSubmitted: boolean = false;
	isdelinked: boolean = false;
	//islink: boolean = false;
	//linkflag = "start";
	submitted=false;
	communicationtype; //Vijay
	consenttemplateid: any;
	linkflag= "false"; //for delink linkflag=false
	linkingForm: FormGroup;
	//myimage:string = "assets/images/rightclick.png";
	cstempids = [];
	cstemplate_id: any
	
	constructor(private fb: FormBuilder,
		private ps: APIPaymentService,
		private $modal: $ModalManagerService,
		private db: $DBManagerService,
		private _route: ActivatedRoute,
		private cst: APIConsentService,
		private gs: GstRegistrationService,
		private modalService: BsModalService,
		private router: Router) {
		this._route.params.subscribe((params) => {
			this.entity_id = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
			this.entity_name = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
			this.template_id = this.db.get(Constants.SESSSION_STORAGE, Constants.TM_ID);
			this.communicationtype = this.db.get(Constants.SESSSION_STORAGE, Constants.MODEOFCOMMUNICATION);
			//this.consenttemplateid = this.db.get(Constants.SESSSION_STORAGE, Constants.CONSENTTEMPLATEID);
			this.cstemplate_id = this.db.get(Constants.SESSSION_STORAGE, Constants.CONSENTTEMPLATEID);
			this.linkflag = this.db.get(Constants.SESSSION_STORAGE, Constants.CSTLINKDELINK);
			
		});
	}
	get f() { return this.linkingForm.controls; }



	ngOnInit() {
		this.linkingForm = this.fb.group({
			entity_id: ['',],
			entity_name: ['',],
			template_id: ['',],
			communicationtype: ['',],
			cstemplate_id: ['', [Validators.required]],
			cstemplate_id1: ['', [Validators.maxLength(19), Validators.minLength(19)]],
			//consenttemplateid: ['',]
			
		});

		this.linkingForm.controls['entity_id'].setValue(this.entity_id);
		this.linkingForm.controls['entity_name'].setValue(this.entity_name);
		this.linkingForm.controls['template_id'].setValue(this.template_id);
		this.linkingForm.controls['communicationtype'].setValue(this.communicationtype);
		console.log("++++++++++++++++++++I am In+++++++++++++++++",this.linkflag );
		console.log("++++++++++++++++++++this.consenttemplateid+++++++++++++++++",this.consenttemplateid);
		//this.linkflag=false;
		//this.linkingForm.controls['CSTLINKDELINK'].setValue(this.linkflag);
		//this.linkingForm.controls['consenttemplateid'].setValue(this.consenttemplateid);
		this.linkingForm.controls['cstemplate_id'].setValue(this.cstemplate_id);
	/*	if(this.linkflag == false){			
			this.islink=false
		}
		else{
			this.islink=true
		}*/
		let data = {
			entity_id: this.entity_id
		}	
		
		//this.cst.fetchCSTID(this.entity_id).subscribe((res) => {
		this.cst.fetchCSTID(data).subscribe((res) => {
			this.cstempids = res.data
			this.cstempids.push({ cstemplate_id: 'Others' })
		})
	}


	verifyCsTemp() {
	
	
		let data = {}
		let cstempid = this.linkingForm.get('cstemplate_id').value

		if (cstempid != 'Others') {
			data = {
				"cst_id" :cstempid,
				"entity_id":this.linkingForm.get('entity_id').value,
				"template_id":this.linkingForm.get('template_id').value
			}
		}
		else {
			let cstempid = this.linkingForm.get('cstemplate_id1').value
			
			data = {
				"cst_id" :cstempid,
				"entity_id":this.linkingForm.get('entity_id').value,
				"template_id":this.linkingForm.get('template_id').value
			}
		}
			console.log("---------------data---------------",data);
		//this.verifyCSTempID = true
		 this.cst.verifycst(data)
			.subscribe(r => {
				console.log(r)
				if (r.status == "success" ) {
					this.verifyCSTempID = 'success'
					this.cs_temp_content = r.data[0].cst_content
					 
					this.$modal.successModal({
							title: 'success',
							msg: 'The Consent template id is active. Click on submit to link it.'
						})
					console.log("---------------content---------------",this.cs_temp_content);
					this.isValid = true;
				
				}
				else {
						this.verifyCSTempID = 'fail'
						this.cs_temp_content=""
						this.$modal.errorModal({
							title: 'fail',
							msg: "The consent id updated is incorrect or not active/mapped against your entity, please retry with a valid ID (Refer Entity Consent Template Report)" 
						})
					}
	
			});

	}
	
	
	
	//for Form submition
	onSubmit() {
		this.submitted = true;
		if (this.linkingForm.invalid) {
			let invalid = [];
			let controls = this.linkingForm.controls;
			for (const name in controls) {
				if (controls[name].invalid) {
					invalid.push(name);
				}
			}
			return;
		}
		else {
			console.log("-----------------this.linkflag ------------", this.linkflag);
			if ((this.linkflag == "false") || (this.linkflag == "true" && this.verifyCSTempID == 'success')) {
				////////////////////////////////

				this.modalRef = this.modalService.show(ModalPromptEntityComponent)
				this.modalRef.content.modalDataObj = {
					title: "Consent Template Linking/Delinking",
					msg: "Do you want to Link/Delink the Consent Template with this Template ID?",
					btnYes: 'Yes',
					btnNo: 'No'
				}
				this.modalRef.content.onClose.subscribe(result => {
					this.returnedValue = result

					if (this.returnedValue == true) {
						/////////////////////////

						//if (confirm(" Do you want to link the Consent template to this Template Id? ")) {

							let data = {}
							let cstempid = this.linkingForm.get('cstemplate_id').value
				
							if (cstempid != 'Others') {
								data = {
									"cst_id" :cstempid,
									"entity_id":this.linkingForm.get('entity_id').value,
									"template_id":this.linkingForm.get('template_id').value,
									"islink":this.linkflag,
								}
							}
							else {
								let cstempid = this.linkingForm.get('cstemplate_id1').value
								data = {
									"cst_id" :cstempid,
									"entity_id":this.linkingForm.get('entity_id').value,
									"template_id":this.linkingForm.get('template_id').value,
									"islink":this.linkflag,
								}
							}

						this.cst.linkcst(data)
							.subscribe(r => {
								console.log(r)
								if (r.status == "success") {

									this.$modal.successModal({
										title: 'Consent Template - Link/Delink',
										msg: r.message
									})
									this.isSubmitted = true;
									this.isdelinked = true;
								}
								else {

									this.$modal.errorModal({
										title: 'Consent Template - Link/Delink',
										msg: r.message
									})
								}

							})
					}
				})
			}

			else {
				alert(" Only upon Successful verification, the request can be submitted");
			}

		}

	}

}